var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAntimatterIcon = function SvgAntimatterIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8106 16.3981C16.4989 16.3981 17.8675 15.0338 17.8675 13.3509C17.8675 11.6681 16.4989 10.3039 14.8106 10.3039C13.1223 10.3039 11.7537 11.6681 11.7537 13.3509C11.7537 15.0338 13.1223 16.3981 14.8106 16.3981ZM18.8826 13.3509C18.8826 15.5927 17.0595 17.4099 14.8106 17.4099C12.5617 17.4099 10.7386 15.5927 10.7386 13.3509C10.7386 11.1092 12.5617 9.29199 14.8106 9.29199C17.0595 9.29199 18.8826 11.1092 18.8826 13.3509Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3036 15.45C12.5065 15.6983 12.4691 16.0635 12.22 16.2658C10.1055 17.9826 7.90342 19.1807 5.95668 19.7041C4.0375 20.2202 2.20462 20.115 1.04469 18.9588C-0.243046 17.6752 -0.234981 15.5692 0.498313 13.4025C0.60101 13.099 0.931038 12.936 1.23545 13.0384C1.53988 13.1407 1.7034 13.4698 1.60071 13.7732C0.90471 15.8297 1.07018 17.3441 1.86737 18.1388C2.58329 18.8524 3.87863 19.0618 5.65371 18.5845C7.40128 18.1145 9.45954 17.0114 11.4852 15.3666C11.7343 15.1644 12.1007 15.2017 12.3036 15.45Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24423 4.09624C8.04902 3.84185 8.09765 3.47792 8.3528 3.28334C10.3816 1.73635 12.4659 0.671284 14.3054 0.229132C16.123 -0.207732 17.847 -0.0633395 18.9552 1.04126C20.2429 2.32487 20.2348 4.43087 19.5016 6.59758C19.3989 6.90105 19.0688 7.06407 18.7644 6.96166C18.46 6.85931 18.2965 6.53034 18.3992 6.22693C19.0951 4.17036 18.9297 2.65591 18.1325 1.8613C17.449 1.18004 16.239 0.957325 14.5781 1.35653C12.9392 1.75045 11.0004 2.72462 9.0597 4.20446C8.80454 4.39905 8.43945 4.35058 8.24423 4.09624Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1579 6.39196C10.1579 8.63365 8.33477 10.4509 6.08587 10.4509C3.83697 10.4509 2.01385 8.63365 2.01385 6.39196C2.01385 4.15026 3.83697 2.33301 6.08587 2.33301C8.33477 2.33301 10.1579 4.15026 10.1579 6.39196ZM5.67854 4.3622H6.49294V5.98563H8.12113V6.79742H6.49294V8.42115H5.67854V6.79742H4.04908V5.98563H5.67854V4.3622Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2653 13.698V12.8862H13.3567V13.698H16.2653Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAntimatterIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/antimatter_icon.4ca22081.svg";
export { ForwardRef as ReactComponent };